export const convertUndefinedToNull = <TType>(value: TType | undefined | null): TType | null => {
  return value ?? null;
};
